import { useQuery } from '@tanstack/react-query';
import { productConfig } from '@shared/config';
import { getPublicConfig, type PublicConfig } from '@/lib/api';
import { queryKeys } from '@/lib/query';

const fallbackConfig = {
  brandName: productConfig.brandName,
  billingEnabled: false,
  freeDuringBeta: false,
  turnstileRequired: false,
  turnstileSiteKey: null,
} as const;

export function isRegistrationConfigReady(input: {
  isPending: boolean;
  isUnavailable: boolean;
  config: PublicConfig;
}): boolean {
  if (input.isPending || input.isUnavailable) return false;
  return !input.config.turnstileRequired || Boolean(input.config.turnstileSiteKey);
}

export function usePublicConfig() {
  const query = useQuery({
    queryKey: queryKeys.publicConfig,
    queryFn: getPublicConfig,
    staleTime: 30 * 60_000,
  });

  return {
    ...query,
    config: query.data ?? fallbackConfig,
    /** Public registration must not infer a permissive security configuration. */
    isUnavailable: query.isError,
  };
}
